import classNames from 'classnames';
import { useCallback } from 'react';
import { Flex, Heading } from 'yoso';
import { LoginButton } from '~/components/Auth';
import { BrandLikeButton } from '~/components/Dosi/Brand/Like/BrandLikeButton';
import { DosiProfileNav } from '~/components/Dosi/Nav/DosiProfileNav';
import { GlobalNavbar } from '~/components/Header/Nav';
import { T } from '~/components/I18n';
import { Discord, Medium, Twitter } from '~/components/Icon';
import { Chevron } from '~/components/Icon/Chevron';
import { InlineList } from '~/components/List/Inline/InlineList';
import { useMember } from '~/components/Member/Member.hooks';
import { Link } from '~/components/Route/Link';
import { Sidebar } from '~/components/Sidebar/Sidebar';
import { useBodyScrollLock, useSidebarStore } from '~/components/Sidebar/Sidebar.hooks';
import { useTwitterUrl } from '~/components/Url/Url.hooks';
import styles from './CitizenSidebar.module.scss';

export type CitizenSidebarProps = {
  className?: string;
};

export const CitizenSidebar = ({ className }: CitizenSidebarProps) => {
  const {
    data: { isLoggedIn },
  } = useMember();
  const { ref } = useBodyScrollLock<HTMLDivElement>(false);
  const { setActive } = useSidebarStore();
  const onProfileNavClick = useCallback(() => {
    setActive(false);
  }, [setActive]);
  const twitterUrl = useTwitterUrl();

  return (
    <Sidebar className={classNames(styles.root, className)}>
      <div className={styles.inner} ref={ref}>
        <div className={styles.body}>
          <div className={styles.profile}>
            <Flex container justifyContent="space-between" alignItems="center">
              <Link to="/">
                <Heading level={4} className={styles.brand}>
                  DOSI Citizen
                </Heading>
              </Link>
              {isLoggedIn && <BrandLikeButton />}
            </Flex>
            {isLoggedIn ? (
              <DosiProfileNav className={styles.profileNav} onClick={onProfileNavClick} />
            ) : (
              <LoginButton className={styles.loginButton}>
                <T name="citizen_login_btn" />
                <Chevron direction="right" size="small" className={styles.chevron} />
              </LoginButton>
            )}
          </div>
          <GlobalNavbar className={styles.navBar} />
        </div>
        <div className={styles.footer}>
          <InlineList className={styles.externalServiceList}>
            <li>
              <a
                target="discord"
                href="https://discord.gg/SCkEdqTJG7"
                data-event="click"
                data-event-target="gnb_discord">
                <Discord display="block" />
              </a>
            </li>
            <li>
              <a
                target="twitter"
                href={twitterUrl}
                data-event="click"
                data-event-target="gnb_twitter">
                <Twitter display="block" />
              </a>
            </li>
            <li>
              <a
                target="medium"
                href="https://medium.com/@DOSI_official"
                data-event="click"
                data-event-target="gnb_medium">
                <Medium display="block" />
              </a>
            </li>
          </InlineList>
        </div>
      </div>
    </Sidebar>
  );
};
